import { useTheme } from "styled-components";
import Text from "common/Typography/Text";
import React from "react";
import Modal from "common/Modal/Modal";
import Title from "common/Typography/Title";
import { BacktestingRunType, BotType, LanguageNameSpaces } from "@shared/types";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery";
import {
  APPLIED_BACKTESTING_QUERY_PARAM,
  BACKTESTING_BOT_QUERY_PARAM,
} from "features/bots/common/constants";
import useQuery from "utils/hooks/useQuery";
import { useConfirmDeleteModal } from "@shared/features/bots/BotForm/Backtesting/hooks";
import { displayResultMessage } from "utils/misc";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface ConfirmDeleteModalProps {
  backtestingRun?: BacktestingRunType;
  closeModal: () => void;
  isSeeAllScreen?: boolean;
  botType: BotType;
}

const ConfirmDeleteModal = ({
  backtestingRun,
  closeModal,
  isSeeAllScreen,
  botType,
}: ConfirmDeleteModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const { isNewLook } = useTheme();
  const { appendQuery } = useHistoryWithQuery();
  const query = useQuery();
  const { handleDelete, deleteLoading } = useConfirmDeleteModal({
    queryBacktest: Number(query.get(APPLIED_BACKTESTING_QUERY_PARAM)),
    backtestingRun,
    closeModal,
    unapplyBacktest: () => {
      appendQuery(undefined, [
        APPLIED_BACKTESTING_QUERY_PARAM,
        BACKTESTING_BOT_QUERY_PARAM,
      ]);
    },
    displayResultMessage,
    isSeeAllScreen,
    botType,
  });

  return (
    <Modal
      title={t("modals.delete_backtesting")}
      open={!!backtestingRun}
      onCancel={closeModal}
      onOk={handleDelete}
      okButtonProps={{ loading: deleteLoading }}
      okText={t("buttons.yes")}
      cancelText={t("buttons.no")}
    >
      {isNewLook ? (
        <Text type="secondary">{t("backtesting.modals.delete_message")}</Text>
      ) : (
        <Title level={4}>{t("backtesting.modals.delete_message")}</Title>
      )}
    </Modal>
  );
};

export default ConfirmDeleteModal;
